var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-layout",class:{ 'one-col': !_vm.hasRight }},[_c('div',{staticClass:"left"},[_vm._t("left")],2),(_vm.hasRight)?_c('div',{staticClass:"right"},[_vm._t("right")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }